// import { SearchToolOrderInput } from '@bechtel/ht-types';
import { useMutation } from '@apollo/client';
import { RetryOutboundInterfaceInput, UpdateOutboundInterfaceResult } from '@bechtel/ht-types';
import { useCallback } from 'react';
import { RESYNC_FAILED_OUTBOUND } from '~/gql';

export const useResyncFailureData = (refetchQueries = ['SearchOutboundInterfaces']) => {
  const [retryOutboundInterface, { data, loading, error }] = useMutation<
    { retryOutboundInterface: UpdateOutboundInterfaceResult },
    { retryOutboundInterfaceInput: RetryOutboundInterfaceInput }
  >(RESYNC_FAILED_OUTBOUND, {
    refetchQueries: refetchQueries,
  });

  const retryFailedOutboundInterface = useCallback(
    (
      retryOutboundInterfaceInput: RetryOutboundInterfaceInput,
      onComplete?: (data) => void,
      onError?: (err) => void
    ) => {
      retryOutboundInterface({
        variables: {
          retryOutboundInterfaceInput: retryOutboundInterfaceInput,
        },
        onCompleted: (data) => {
          if (onComplete) {
            onComplete(data);
          }
        },
        onError: (err) => {
          if (onError) {
            onError(err);
          }
        },
      });
    },
    [retryOutboundInterface]
  );

  return { retryFailedOutboundInterface, data, loading, error };
};
